import 'picturefill';
import 'lazysizes';
import { scrollToTop } from './modules/scrollto-top';
window.addEventListener('DOMContentLoaded', () => {
    switch (PAGE_TYPE) {
        case 'top':
            import('./modules/item-list');
            break;
        case 'shoplist':
            import('./modules/shop-list');
            break;
    }
});
window.addEventListener('load', () => {
    scrollToTop('.scrolltop');
});
